import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';
import { PCDBSearchResult } from './useSearchPCDB';

interface SuggestSimilarPartsInput {
    partTerminologyName: string;
    categoryId: number;
    subcategoryId: number;
}

interface SuggestSimilarPartsResponse {
    suggestions: PCDBSearchResult[];
}

const suggestSimilarParts = async (
    input: SuggestSimilarPartsInput,
    sessionId: string
): Promise<SuggestSimilarPartsResponse> => {
    const { data } = await axios.post(`${API_URL}/pcdb/suggest-similar`, input, {
        headers: {
            Authorization: sessionId
        }
    });
    return data;
};

export const useSuggestSimilarParts = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: SuggestSimilarPartsInput) =>
            suggestSimilarParts(input, sessionContext?.sessionId ?? ''),
    });
};
